module.exports = __webpack_public_path__ + "static/media/Skyfarm Drive, Santa Rosa, CA2.55dcaf2c.jpg";